var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViseur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 595.3",
    style: {
      enableBackground: "new 0 0 595.3 595.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.6,250.6L297.6,250.6c-11.7,0-21.3-9.5-21.3-21.3V21.3c0-11.7,9.5-21.3,21.3-21.3h0 c11.7,0,21.3,9.5,21.3,21.3v208.1C318.9,241.1,309.4,250.6,297.6,250.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.6,595.3L297.6,595.3c-11.7,0-21.3-9.5-21.3-21.3V366c0-11.7,9.5-21.3,21.3-21.3h0 c11.7,0,21.3,9.5,21.3,21.3V574C318.9,585.8,309.4,595.3,297.6,595.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M595.3,297.6L595.3,297.6c0,11.7-9.5,21.3-21.3,21.3H366c-11.7,0-21.3-9.5-21.3-21.3v0 c0-11.7,9.5-21.3,21.3-21.3H574C585.8,276.4,595.3,285.9,595.3,297.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,297.6L0,297.6c0-11.7,9.5-21.3,21.3-21.3h208.1c11.7,0,21.3,9.5,21.3,21.3v0c0,11.7-9.5,21.3-21.3,21.3H21.3 C9.5,318.9,0,309.4,0,297.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViseur);
export default __webpack_public_path__ + "static/media/viseur.3f4facb8.svg";
export { ForwardRef as ReactComponent };